import { render, staticRenderFns } from "./_preference-widgets.vue?vue&type=template&id=013d13a6"
import script from "./_preference-widgets.vue?vue&type=script&lang=js"
export * from "./_preference-widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports